import { createReducer } from '@reduxjs/toolkit';
import { RequestError, Circulations } from 'types';
import { saveBlob } from '../../utils/save-blob';
import {
  fetchCirculations,
  fetchedCirculations,
  refreshCirculations,
  refreshedCirculations,
  exportCirculations,
  exportedCirculations,
  setShoudUsePersistedCirculationsFilters,
  setPersistedCirculationsFilters,
} from './actions';

import { CirculationsState } from './types';

export const INITIAL_STATE: CirculationsState = {
  status: undefined,
  error: undefined,
  data: undefined,
  refreshedDate: undefined,
  shoudUsePersistedCirculationsFilters: undefined,
  persistedCirculationsFilters: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<CirculationsState>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchCirculations, (state) => {
      state.status = 'loading';
    })
    .addCase(refreshCirculations, (state) => {
      state.status = 'loading';
    })
    .addCase(exportCirculations, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedCirculations, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
        state.data = payload as Circulations;
      }
    })
    .addCase(refreshedCirculations, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
        state.data = payload as Circulations;
        state.refreshedDate = new Date().toISOString();
      }
    })
    .addCase(exportedCirculations, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        const returnState = saveBlob(payload, 'Services');
        state.error = returnState.error;
        state.status = returnState.status;
      }
    })

    .addCase(setShoudUsePersistedCirculationsFilters, (state, action) => {
      const { payload } = action;
      state.shoudUsePersistedCirculationsFilters = payload;
    })

    .addCase(setPersistedCirculationsFilters, (state, action) => {
      const { payload } = action;
      state.persistedCirculationsFilters = payload;
    })
);
